/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import React from 'react';
import type { Match, RouterHistory } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import CallUsPage from '../../components/CallUsPage/CallUsPage';
import { iconsAndTitles } from '../../constants';
import { breakdownPhoneNumber } from '../../constants/phoneNumbers';
import { insuranceTypeParameter } from '../../helpers';


const BreakdownAssistance = ({ match, history }: { match: Match, history: RouterHistory }) => {
  const type = insuranceTypeParameter(match);

  return <CallUsPage
    history={history}
    icon={iconsAndTitles[type].icon}
    title="Breakdown Assistance"
    contentText="For breakdown assistance please call us on"
    phoneNumber={breakdownPhoneNumber}
  />
};

export default withRouter(BreakdownAssistance);
